import React, { useEffect } from "react";
import AdminGrid from "../../components/admin/admin-grid";
import { awsRum } from "../..";
import { RUMPage } from "../../enums/rum";

const AdminPage = () => {
  useEffect(() => {
    try{
      awsRum.recordPageView(RUMPage.ADMIN);
    }
    catch{
      // Swallow rum errors
    }
    
  }, [])
  
  return <AdminGrid />;
};

export default AdminPage;
